var _defs, _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#04246a;}.c{fill:#e20101;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 64,
    height: 64
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M40.037,56H3.943A3.878,3.878,0,0,1,0,52.2V3.8A3.878,3.878,0,0,1,3.943,0H40.037a3.878,3.878,0,0,1,3.944,3.8V19.01a.99.99,0,1,1-1.979,0V3.8a1.9,1.9,0,0,0-1.965-1.812H3.943A1.9,1.9,0,0,0,1.978,3.8V52.2a1.9,1.9,0,0,0,1.965,1.812H40.037A1.9,1.9,0,0,0,42,52.2V49a.99.99,0,1,1,1.979,0v3.2A3.879,3.879,0,0,1,40.037,56ZM17.993,47H10.006a1,1,0,1,1,0-2h7.987a1,1,0,1,1,0,2Zm0-9H10.006a1,1,0,1,1,0-2h7.987a1,1,0,1,1,0,2Zm0-9H10.006a1,1,0,1,1,0-2h7.987a1,1,0,1,1,0,2Zm16-9H10.006a1,1,0,1,1,0-2H33.993a1,1,0,1,1,0,2Zm0-9H10.006a1,1,0,1,1,0-2H33.993a1,1,0,1,1,0,2Z",
    transform: "translate(6.001 4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M24.434,20.626H22.02V0h6.21V2.028h-3.8V8.542H28v2.052H24.434V20.625Zm-9.978,0h-3.8V0h3.88A3.517,3.517,0,0,1,17.8,1.459a8.016,8.016,0,0,1,.89,4.142l.012,9.06a8.252,8.252,0,0,1-.972,4.57A3.721,3.721,0,0,1,14.456,20.625Zm-1.384-18.7V18.667h1.242a1.87,1.87,0,0,0,1.1-.28c.568-.405.856-1.533.856-3.353V5.543a6.215,6.215,0,0,0-.458-2.778,1.582,1.582,0,0,0-1.5-.844ZM2.426,20.624H0V0H4.15A3.2,3.2,0,0,1,7.594,2.274a11.276,11.276,0,0,1,.445,3.34c0,1.259-.035,2.225-.105,2.87a5.455,5.455,0,0,1-1.112,3.076,3.452,3.452,0,0,1-2.672.967H2.426v8.1Zm0-18.7v8.59H3.9a1.333,1.333,0,0,0,1.37-.9,11.224,11.224,0,0,0,.34-3.388v-.4A9.584,9.584,0,0,0,5.28,2.813a1.29,1.29,0,0,0-1.319-.89Z",
    transform: "translate(29 29)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDocuments);
export default __webpack_public_path__ + "static/media/logo_documents.e52008ef9f157fa86ec8e5238be1a802.svg";
export { ForwardRef as ReactComponent };